import { getAppConfig } from './services/configService'
import { createAppInsights, getDeviceToken, includeHotjar } from './helpers'

export async function initializeApp(history) {
    const [config, deviceToken] = await Promise.all([
        getAppConfig(),
        getDeviceToken(true)
    ]).catch(error => {
        // This needs a retry
        console.error(`Could not load initial app requirements`)
    })

    createAppInsights({
        deviceToken,
        history,
        instrumentationKey: config.appInsightsKey
    })

    if (config.useHotjar) {
        includeHotjar(deviceToken)
    }

    return config
}